import { useContext } from 'react';
import SettingsContext from './context';

export const useSettingsContext = () => useContext(SettingsContext);